import { render, staticRenderFns } from "./ActivityLogCard.vue?vue&type=template&id=2b0ef21a&scoped=true&"
import script from "./ActivityLogCard.vue?vue&type=script&lang=js&"
export * from "./ActivityLogCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogCard.vue?vue&type=style&index=0&id=2b0ef21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ef21a",
  null
  
)

export default component.exports